module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Barcode-read-ead460ce93e39df9dd16bf98a641e0a4.svg";